export default __webpack_public_path__ + "static/media/1.c37d97fb.jpg";